/**
 * Weight Disputes (v2) — reference data.
 * Statuses are the real stored Proship values, verbatim keys: the eight from
 * the live Select Status dropdown plus SETTLED_PROSHIP, added with Weight v2
 * Item 3 (15 Sep 2026). Do not add to this list without a backend enum value.
 * RELABELLED: REJECTED_PROSHIP's display label was changed from
 * 'Rejected Proship' to 'Rejected by courier', and it was dropped from the
 * Resolved tab's `statuses` (ACCEPTED_PROSHIP dropped alongside it) — both
 * still real stored values, still verbatim keys; only the label text
 * and tab membership changed.
 */
export const NOW = new Date('2026-08-07T00:00:00Z')

export const STATUS = {
  NEW:                  {label: 'New',                     tone: 'info',    group: 'action'},
  DISPUTED_BY_MERCHANT: {label: 'Disputed By Merchant',    tone: 'ai',      group: 'dispute'},
  DISPUTED_BY_COURIER:  {label: 'Disputed By Courier',     tone: 'warn',    group: 'dispute'},
  ACCEPTED_BY_MERCHANT: {label: 'Accepted By Merchant',    tone: 'neutral', group: 'resolved'},
  ACCEPTED_BY_COURIER:  {label: 'Accepted By Courier',     tone: 'ok',      group: 'resolved'},
  ACCEPTED_PROSHIP:     {label: 'Accepted Proship',        tone: 'ok',      group: 'resolved'},
  REJECTED_PROSHIP:     {label: 'Rejected by courier',     tone: 'danger',  group: 'resolved'},
  AUTO_ACCEPTED:        {label: 'Auto Accepted By System', tone: 'danger',  group: 'resolved'},
  // Item 3: closed by Prozo at a revised weight — you paid what your own rate card charges at that
  // weight, and the rest of the hold came back. The row carries settledKg / settledCharge / settledReleased.
  SETTLED_PROSHIP:      {label: 'Settled at revised weight', tone: 'warn',  group: 'resolved'},
}

// D20 (answered 13 Sep): ACCEPTED_PROSHIP — a resolution in the merchant's
// favour by Prozo — is shown under Resolved. Before this the rows were
// reachable from no tab at all.
export const TABS = [
  {id: 'action',    label: 'Action Required',        statuses: ['NEW']},
  {id: 'dispute',   label: 'In Dispute',             statuses: ['DISPUTED_BY_MERCHANT', 'DISPUTED_BY_COURIER']},
  {id: 'resolved',  label: 'Resolved',               statuses: ['ACCEPTED_BY_COURIER', 'REJECTED_PROSHIP', 'ACCEPTED_BY_MERCHANT', 'ACCEPTED_PROSHIP', 'SETTLED_PROSHIP']},
  // 27 Oct (business): nobody acted before the window ran out — its own tab, not mixed into Resolved.
  {id: 'auto',      label: 'Auto Accepted',          statuses: ['AUTO_ACCEPTED']},
  {id: 'sku',       label: 'SKU Weight Intelligence', badge: 'NEW'},
  {id: 'analytics', label: 'Recovery Analytics'},
]

export const DISPUTE_TYPE = {
  HIGHER_VOL:    {label: 'Higher Vol. Weight', short: 'Higher Vol'},
  HIGHER_DEAD:   {label: 'Higher Dead Weight', short: 'Higher Dead'},
  HIGHER_BOTH:   {label: 'Higher Dead & Vol.', short: 'Dead + Vol'},
  WEIGHT_SAVING: {label: 'Weight Saving',      short: 'Saving'},
}

export const REASONS = [
  'Shipment image available', 'Historical charged weight', 'Courier weight scan',
  'Similar products weight', 'Historical sample images', 'Pre-aligned weight',
]

export const COURIERS = [
  {name: 'Delhivery',  services: ['Surface 500gm', 'Surface 1kg', 'Air 500gm']},
  {name: 'Bluedart',   services: ['Surface Reg', 'Air Express']},
  {name: 'Xpressbees', services: ['Surface 500gm', 'Reverse QC']},
  {name: 'Shadowfax',  services: ['Surface 1kg', 'SDD Local']},
  {name: 'DTDC',       services: ['Surface Reg']},
  {name: 'Ekart',      services: ['Surface 500gm']},
  {name: 'Blitz',      services: ['SDD Hyperlocal']},
]

/** Indicative only — no real rate card exists in this repo. */
export const SLAB_RATE = 68
export const SLAB_KG = 0.5
